// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppearanceRouteImport } from './routes/appearance'
import { Route as CbseRouteImport } from './routes/cbse'
import { Route as CollegePredictorRouteImport } from './routes/college-predictor'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as IcseRouteImport } from './routes/icse'
import { Route as IscRouteImport } from './routes/isc'
import { Route as JeeRouteImport } from './routes/jee'
import { Route as JeePreparationTrackerRouteImport } from './routes/jee-preparation-tracker'
import { Route as KcetRouteImport } from './routes/kcet'
import { Route as LabsRouteImport } from './routes/labs'
import { Route as MhtCetRouteImport } from './routes/mht-cet'
import { Route as MindmapsRouteImport } from './routes/mindmaps'
import { Route as NeetRouteImport } from './routes/neet'
import { Route as PaymentStatusRouteImport } from './routes/payment-status'
import { Route as PrerequisitesRouteImport } from './routes/prerequisites'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PyqPredictorRouteImport } from './routes/pyq-predictor'
import { Route as QuestionsRouteImport } from './routes/questions'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RevisionTrackerRouteImport } from './routes/revision-tracker'
import { Route as RevisionsRouteImport } from './routes/revisions'
import { Route as SimulationsRouteImport } from './routes/simulations'
import { Route as StudyPlannerRouteImport } from './routes/study-planner'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestTrackerRouteImport } from './routes/test-tracker'
import { Route as TestsRouteImport } from './routes/tests'
import { Route as ToolkitRouteImport } from './routes/toolkit'
import { Route as Tracker360RouteImport } from './routes/tracker-360'
import { Route as WhatIfRouteImport } from './routes/what-if'
import { Route as AdminIndexingRouteImport } from './routes/admin.indexing'
import { Route as AdminLiveRouteImport } from './routes/admin.live'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as CommunityIndexRouteImport } from './routes/community.index'
import { Route as CommunityAboutRouteImport } from './routes/community.about'
import { Route as CommunityOwnerRouteImport } from './routes/community.owner'
import { Route as CommunitySocialRouteImport } from './routes/community.social'
import { Route as LabsIndexRouteImport } from './routes/labs.index'
import { Route as LabsLabIdRouteImport } from './routes/labs.$labId'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as ProfileEditRouteImport } from './routes/profile.edit'
import { Route as ProfileSettingsRouteImport } from './routes/profile.settings'
import { Route as SimulationsIndexRouteImport } from './routes/simulations.index'
import { Route as SimulationsSimIdRouteImport } from './routes/simulations.$simId'
import { Route as TestsIndexRouteImport } from './routes/tests.index'
import { Route as TestsTestIdRouteImport } from './routes/tests.$testId'
import { Route as TestsPerformanceRouteImport } from './routes/tests.performance'
import { Route as ToolkitIndexRouteImport } from './routes/toolkit.index'
import { Route as ToolkitToolIdRouteImport } from './routes/toolkit.$toolId'
import { Route as TrackerCbseRouteImport } from './routes/tracker.cbse'
import { Route as TrackerJeeMainRouteImport } from './routes/tracker.jee-main'
import { Route as TrackerKcetRouteImport } from './routes/tracker.kcet'
import { Route as TrackerMhtCetRouteImport } from './routes/tracker.mht-cet'
import { Route as TrackerNeetRouteImport } from './routes/tracker.neet'
import { Route as WhatIfIndexRouteImport } from './routes/what-if.index'
import { Route as WhatIfSlugRouteImport } from './routes/what-if.$slug'
import { Route as ToolkitCCategoryIdRouteImport } from './routes/toolkit.c.$categoryId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AppearanceRoute = AppearanceRouteImport.update({
            id: '/appearance',path: '/appearance',getParentRoute: () => rootRouteImport
          })
const CbseRoute = CbseRouteImport.update({
            id: '/cbse',path: '/cbse',getParentRoute: () => rootRouteImport
          })
const CollegePredictorRoute = CollegePredictorRouteImport.update({
            id: '/college-predictor',path: '/college-predictor',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const IcseRoute = IcseRouteImport.update({
            id: '/icse',path: '/icse',getParentRoute: () => rootRouteImport
          })
const IscRoute = IscRouteImport.update({
            id: '/isc',path: '/isc',getParentRoute: () => rootRouteImport
          })
const JeeRoute = JeeRouteImport.update({
            id: '/jee',path: '/jee',getParentRoute: () => rootRouteImport
          })
const JeePreparationTrackerRoute = JeePreparationTrackerRouteImport.update({
            id: '/jee-preparation-tracker',path: '/jee-preparation-tracker',getParentRoute: () => rootRouteImport
          })
const KcetRoute = KcetRouteImport.update({
            id: '/kcet',path: '/kcet',getParentRoute: () => rootRouteImport
          })
const LabsRoute = LabsRouteImport.update({
            id: '/labs',path: '/labs',getParentRoute: () => rootRouteImport
          })
const MhtCetRoute = MhtCetRouteImport.update({
            id: '/mht-cet',path: '/mht-cet',getParentRoute: () => rootRouteImport
          })
const MindmapsRoute = MindmapsRouteImport.update({
            id: '/mindmaps',path: '/mindmaps',getParentRoute: () => rootRouteImport
          })
const NeetRoute = NeetRouteImport.update({
            id: '/neet',path: '/neet',getParentRoute: () => rootRouteImport
          })
const PaymentStatusRoute = PaymentStatusRouteImport.update({
            id: '/payment-status',path: '/payment-status',getParentRoute: () => rootRouteImport
          })
const PrerequisitesRoute = PrerequisitesRouteImport.update({
            id: '/prerequisites',path: '/prerequisites',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PyqPredictorRoute = PyqPredictorRouteImport.update({
            id: '/pyq-predictor',path: '/pyq-predictor',getParentRoute: () => rootRouteImport
          })
const QuestionsRoute = QuestionsRouteImport.update({
            id: '/questions',path: '/questions',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RevisionTrackerRoute = RevisionTrackerRouteImport.update({
            id: '/revision-tracker',path: '/revision-tracker',getParentRoute: () => rootRouteImport
          })
const RevisionsRoute = RevisionsRouteImport.update({
            id: '/revisions',path: '/revisions',getParentRoute: () => rootRouteImport
          })
const SimulationsRoute = SimulationsRouteImport.update({
            id: '/simulations',path: '/simulations',getParentRoute: () => rootRouteImport
          })
const StudyPlannerRoute = StudyPlannerRouteImport.update({
            id: '/study-planner',path: '/study-planner',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TestTrackerRoute = TestTrackerRouteImport.update({
            id: '/test-tracker',path: '/test-tracker',getParentRoute: () => rootRouteImport
          })
const TestsRoute = TestsRouteImport.update({
            id: '/tests',path: '/tests',getParentRoute: () => rootRouteImport
          })
const ToolkitRoute = ToolkitRouteImport.update({
            id: '/toolkit',path: '/toolkit',getParentRoute: () => rootRouteImport
          })
const Tracker360Route = Tracker360RouteImport.update({
            id: '/tracker-360',path: '/tracker-360',getParentRoute: () => rootRouteImport
          })
const WhatIfRoute = WhatIfRouteImport.update({
            id: '/what-if',path: '/what-if',getParentRoute: () => rootRouteImport
          })
const AdminIndexingRoute = AdminIndexingRouteImport.update({
            id: '/admin/indexing',path: '/admin/indexing',getParentRoute: () => rootRouteImport
          })
const AdminLiveRoute = AdminLiveRouteImport.update({
            id: '/admin/live',path: '/admin/live',getParentRoute: () => rootRouteImport
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/admin/payments',path: '/admin/payments',getParentRoute: () => rootRouteImport
          })
const CommunityIndexRoute = CommunityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CommunityRoute
          })
const CommunityAboutRoute = CommunityAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => CommunityRoute
          })
const CommunityOwnerRoute = CommunityOwnerRouteImport.update({
            id: '/owner',path: '/owner',getParentRoute: () => CommunityRoute
          })
const CommunitySocialRoute = CommunitySocialRouteImport.update({
            id: '/social',path: '/social',getParentRoute: () => CommunityRoute
          })
const LabsIndexRoute = LabsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LabsRoute
          })
const LabsLabIdRoute = LabsLabIdRouteImport.update({
            id: '/$labId',path: '/$labId',getParentRoute: () => LabsRoute
          })
const ProfileIndexRoute = ProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProfileRoute
          })
const ProfileEditRoute = ProfileEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => ProfileRoute
          })
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ProfileRoute
          })
const SimulationsIndexRoute = SimulationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SimulationsRoute
          })
const SimulationsSimIdRoute = SimulationsSimIdRouteImport.update({
            id: '/$simId',path: '/$simId',getParentRoute: () => SimulationsRoute
          })
const TestsIndexRoute = TestsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TestsRoute
          })
const TestsTestIdRoute = TestsTestIdRouteImport.update({
            id: '/$testId',path: '/$testId',getParentRoute: () => TestsRoute
          })
const TestsPerformanceRoute = TestsPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => TestsRoute
          })
const ToolkitIndexRoute = ToolkitIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolkitRoute
          })
const ToolkitToolIdRoute = ToolkitToolIdRouteImport.update({
            id: '/$toolId',path: '/$toolId',getParentRoute: () => ToolkitRoute
          })
const TrackerCbseRoute = TrackerCbseRouteImport.update({
            id: '/tracker/cbse',path: '/tracker/cbse',getParentRoute: () => rootRouteImport
          })
const TrackerJeeMainRoute = TrackerJeeMainRouteImport.update({
            id: '/tracker/jee-main',path: '/tracker/jee-main',getParentRoute: () => rootRouteImport
          })
const TrackerKcetRoute = TrackerKcetRouteImport.update({
            id: '/tracker/kcet',path: '/tracker/kcet',getParentRoute: () => rootRouteImport
          })
const TrackerMhtCetRoute = TrackerMhtCetRouteImport.update({
            id: '/tracker/mht-cet',path: '/tracker/mht-cet',getParentRoute: () => rootRouteImport
          })
const TrackerNeetRoute = TrackerNeetRouteImport.update({
            id: '/tracker/neet',path: '/tracker/neet',getParentRoute: () => rootRouteImport
          })
const WhatIfIndexRoute = WhatIfIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WhatIfRoute
          })
const WhatIfSlugRoute = WhatIfSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => WhatIfRoute
          })
const ToolkitCCategoryIdRoute = ToolkitCCategoryIdRouteImport.update({
            id: '/c/$categoryId',path: '/c/$categoryId',getParentRoute: () => ToolkitRoute
          })





const CommunityRouteChildren = {
  CommunityAboutRoute: CommunityAboutRoute,CommunityOwnerRoute: CommunityOwnerRoute,CommunitySocialRoute: CommunitySocialRoute,CommunityIndexRoute: CommunityIndexRoute
}

const CommunityRouteWithChildren = CommunityRoute._addFileChildren(CommunityRouteChildren)




const LabsRouteChildren = {
  LabsLabIdRoute: LabsLabIdRoute,LabsIndexRoute: LabsIndexRoute
}

const LabsRouteWithChildren = LabsRoute._addFileChildren(LabsRouteChildren)




const ProfileRouteChildren = {
  ProfileEditRoute: ProfileEditRoute,ProfileSettingsRoute: ProfileSettingsRoute,ProfileIndexRoute: ProfileIndexRoute
}

const ProfileRouteWithChildren = ProfileRoute._addFileChildren(ProfileRouteChildren)




const SimulationsRouteChildren = {
  SimulationsSimIdRoute: SimulationsSimIdRoute,SimulationsIndexRoute: SimulationsIndexRoute
}

const SimulationsRouteWithChildren = SimulationsRoute._addFileChildren(SimulationsRouteChildren)




const TestsRouteChildren = {
  TestsTestIdRoute: TestsTestIdRoute,TestsPerformanceRoute: TestsPerformanceRoute,TestsIndexRoute: TestsIndexRoute
}

const TestsRouteWithChildren = TestsRoute._addFileChildren(TestsRouteChildren)




const ToolkitRouteChildren = {
  ToolkitToolIdRoute: ToolkitToolIdRoute,ToolkitIndexRoute: ToolkitIndexRoute,ToolkitCCategoryIdRoute: ToolkitCCategoryIdRoute
}

const ToolkitRouteWithChildren = ToolkitRoute._addFileChildren(ToolkitRouteChildren)




const WhatIfRouteChildren = {
  WhatIfSlugRoute: WhatIfSlugRoute,WhatIfIndexRoute: WhatIfIndexRoute
}

const WhatIfRouteWithChildren = WhatIfRoute._addFileChildren(WhatIfRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AppearanceRoute: AppearanceRoute,CbseRoute: CbseRoute,CollegePredictorRoute: CollegePredictorRoute,CommunityRoute: CommunityRouteWithChildren,ContactRoute: ContactRoute,FaqRoute: FaqRoute,FeaturesRoute: FeaturesRoute,IcseRoute: IcseRoute,IscRoute: IscRoute,JeeRoute: JeeRoute,JeePreparationTrackerRoute: JeePreparationTrackerRoute,KcetRoute: KcetRoute,LabsRoute: LabsRouteWithChildren,MhtCetRoute: MhtCetRoute,MindmapsRoute: MindmapsRoute,NeetRoute: NeetRoute,PaymentStatusRoute: PaymentStatusRoute,PrerequisitesRoute: PrerequisitesRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRouteWithChildren,PyqPredictorRoute: PyqPredictorRoute,QuestionsRoute: QuestionsRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,RevisionTrackerRoute: RevisionTrackerRoute,RevisionsRoute: RevisionsRoute,SimulationsRoute: SimulationsRouteWithChildren,StudyPlannerRoute: StudyPlannerRoute,TermsRoute: TermsRoute,TestTrackerRoute: TestTrackerRoute,TestsRoute: TestsRouteWithChildren,ToolkitRoute: ToolkitRouteWithChildren,Tracker360Route: Tracker360Route,WhatIfRoute: WhatIfRouteWithChildren,AdminIndexingRoute: AdminIndexingRoute,AdminLiveRoute: AdminLiveRoute,AdminPaymentsRoute: AdminPaymentsRoute,TrackerCbseRoute: TrackerCbseRoute,TrackerJeeMainRoute: TrackerJeeMainRoute,TrackerKcetRoute: TrackerKcetRoute,TrackerMhtCetRoute: TrackerMhtCetRoute,TrackerNeetRoute: TrackerNeetRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)